import Error404 from 'pages/error/Error404';
import { useSettingsPanelContext } from 'providers/SettingsPanelProvider';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from 'store/rootReducer';

function InstitutionRouteHandler() {
  const { userType } = useSelector((state: RootState) => state.user.user);

  const { setSettingsPanelConfig } = useSettingsPanelContext();

  useEffect(() => {
    setSettingsPanelConfig({ showSettingPanelButton: true });
  }, []);

  return userType && userType === 'institution' ? <Outlet /> : <Error404 />;
}

export default InstitutionRouteHandler;
